<template>
  <b-row>
    <b-col lg="12">
      <div
        id="container"
        class="d-flex justify-content-start"
      >
        <svg
          :width="isSmallScreen() ? '100%' : '1243px'"
          :height="isSmallScreen() ? '100%' : '100%'"
          viewBox="0 0 1511 359"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48.6682 359L1431.47 358.059H1460.05H1511V313.5V146V131.5V0H1380.13H737.654H616.329H75.7985H0V53.2095V311.014V359H48.6682Z"
            fill="#000e10"
            fill-opacity="0.5"
          />

          <!-- สัดส่วนเวลาในการปล่อยไฟแต่ละ Phase (วัน) -->
          <!-- <foreignObject
            width="50%"
            height="100%"
            x="15"
            y="20"
          >
            <div>
              <svg
                width="1143"
                height="154"
                viewBox="0 0 1143 154"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.2">
                  <path
                    d="M507.159 118.184H623.083H1111V23H32L33.7942 95.7745V118.184H507.159Z"
                    fill="url(#paint0_linear_26_2)"
                    fill-opacity="0.5"
                  />
                </g>
                <g filter="url(#filter0_d_26_2)">
                  <path
                    d="M1108 123.184C1110.76 123.184 1113 120.945 1113 118.184C1113 115.422 1110.76 113.184 1108 113.184V123.184ZM30 123.184H1108V113.184H30V123.184Z"
                    fill="url(#paint1_linear_26_2)"
                  />
                </g>
                <g
                  id="bolt1"
                  filter="url(#filter1_df_26_2)"
                >
                  <path
                    d="M37.9988 25.7111C37.9408 22.9502 35.6557 20.7592 32.8949 20.8172C30.1341 20.8752 27.943 23.1603 28.001 25.9211L37.9988 25.7111ZM28.001 25.9211L30.0011 121.105L39.9989 120.895L37.9988 25.7111L28.001 25.9211Z"
                    fill="#00E7FF"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_26_2"
                    x="0"
                    y="83.1839"
                    width="1143"
                    height="70"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="15" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.183437 0 0 0 0 0.340519 0 0 0 0 0.375 0 0 0 0.49 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                  </filter>
                  <filter
                    id="filter1_df_26_2"
                    x="7.99991"
                    y="0.816069"
                    width="51.999"
                    height="140.289"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="2.5"
                      result="effect2_foregroundBlur_26_2"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_26_2"
                    x1="1111.03"
                    y1="105.071"
                    x2="33.79"
                    y2="105.071"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop />
                    <stop
                      offset="0.0810585"
                      stop-color="#000506"
                    />
                    <stop
                      offset="0.1876"
                      stop-color="#001416"
                    />
                    <stop
                      offset="0.3084"
                      stop-color="#205274"
                    />
                    <stop
                      offset="0.4397"
                      stop-color="#27628A"
                    />
                    <stop
                      offset="0.5795"
                      stop-color="#3585BB"
                    />
                    <stop
                      offset="0.724"
                      stop-color="#00A0C3"
                    />
                    <stop
                      offset="0.8554"
                      stop-color="#00B3FF"
                    />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_26_2"
                    x1="30"
                    y1="118.684"
                    x2="1108"
                    y2="118.684"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#0D6E89" />
                    <stop
                      offset="0.421"
                      stop-color="#2A929C"
                      stop-opacity="0.5"
                    />
                    <stop
                      offset="0.681"
                      stop-color="#1C6269"
                      stop-opacity="0.2"
                    />
                    <stop
                      offset="1"
                      stop-color="#2F5760"
                      stop-opacity="0.15"
                    />
                  </linearGradient>
                </defs>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="80"
                  y="40"
                >
                  <span style="font-size: 50px;">สัดส่วนเวลาในการปล่อยไฟแต่ละ Phase (วัน)</span>
                </foreignObject>
              </svg>
            </div>
          </foreignObject> -->

          <foreignObject
            width="100%"
            height="100%"
            x="-16"
            y="10"
          >
            <div id="boltX2">
              <TrafficSciPhase />
            </div>
          </foreignObject>

          <foreignObject
            width="100%"
            height="100%"
            x="1470"
            y="10"
          >
            <div>
              <feather-icon
                v-b-modal="'Live1'"
                :style="{ color: 'rgba(0, 228, 255, 0.5)' }"
                icon="CameraIcon"
                size="22"
              />
            </div>
            <Live
              ref="RTSP"
            />
          </foreignObject>
        </svg>
      </div>

    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol,
  // BCard,
} from 'bootstrap-vue'
import TrafficSciPhase from '@/views/traffiscifi/detailfi/TrafficSciPhase.vue'
import Live from '@/views/traffiscifi/detailfi/ModalRTSP.vue'

export default {
  // name: 'SVGAnimation',
  components: {
    BRow,
    BCol,
    // BCard,
    Live,

    TrafficSciPhase,
  },
  data() {
    return {
      // animate: false,

      // การนับจำนวนเร็ว
      FastCounting: {
        count: 0,
        targetCount: 9832,
        duration: 6000, // Duration in milliseconds
      },
      FastCounting2: {
        count2: 0,
        targetCount2: 2826,
        duration2: 5000, // Duration in milliseconds
      },
    }
  },
  computed: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.isSmallScreen)
  },
  mounted() {
    // การนับจำนวนเร็ว
    this.startCounting1()
    this.startCounting2()

    window.addEventListener('resize', this.isSmallScreen)
    this.interval = setInterval(() => {
      window.addEventListener('resize', this.isSmallScreen)
    }, 100000)
  },
  methods: {
    isSmallScreen() {
      return window.innerWidth <= 850
    },

    // การนับจำนวนเร็ว
    startCounting1() {
      const startTime = performance.now()
      const updateCount = currentTime => {
        const elapsedTime = currentTime - startTime
        if (elapsedTime < this.FastCounting.duration) {
          this.FastCounting.count = Math.round((elapsedTime / this.FastCounting.duration) * this.FastCounting.targetCount)
          requestAnimationFrame(updateCount)
        } else {
          this.FastCounting.count = this.FastCounting.targetCount
        }
      }
      requestAnimationFrame(updateCount)
    },
    startCounting2() {
      const startTime = performance.now()
      const updateCount = currentTime => {
        const elapsedTime = currentTime - startTime
        if (elapsedTime < this.FastCounting2.duration2) {
          this.FastCounting2.count2 = Math.round((elapsedTime / this.FastCounting2.duration2) * this.FastCounting2.targetCount2)
          requestAnimationFrame(updateCount)
        } else {
          this.FastCounting2.count2 = this.FastCounting2.targetCount2
        }
      }
      requestAnimationFrame(updateCount)
    },
  },

}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

#container {
  // height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
svg {
  max-width: 100%;
  height: auto;
  background: none; /* Ensures no background color */
  fill: rgba(0, 7, 33, 0.573); /* Prevents fill patterns from having unwanted backgrounds */
}

// .full-screen-svg {
//   background-color: transparent;
//   // pointer-events: none;

//   path { // Targeting all possible shapes
//     // fill: none;
//     // stroke: #fff;
//     opacity: 0.5; // Making shapes semi-transparent
//   }
// }

// .spanblue {
//   font-size: 44px;
//   font-weight: 500;
//   color: #46E0E5;
//   text-shadow: 0 0 4px #46E0E5;
// }

#heart {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: #F06;

  width: 150px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 1, 6;
  stroke-dashoffset: 54;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 2s ease-in infinite like,
  0.8s linear 2s 2 forwards beat,
  2s ease-in-out infinite fadeStroke;
  // stroke: rgb(255, 87, 51);

  @keyframes like {
  0% {
    stroke-dashoffset: 54;
    fill: var(--grey);
  }

  70% {
    stroke-dashoffset: 0;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    fill: rgba(0, 36, 182, 0.3)
  }
}

@keyframes beat {
  0% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(0.9, 0.9);
  }

  100% {
    transform: scale(1, 1);
  }

}

@keyframes fadeStroke {
    0%, 100% {
      stroke-width: 1;
    }
    50% {
      stroke-width: 0;
    }
  }
}

#circle1 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: rgb(0, 204, 255);

  width: 200px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 16, 10;
  stroke-dashoffset: 52;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 3s ease-in infinite likecircle1,
  // 0.8s linear 2s 2 forwards beat,
  3s ease-in-out infinite fadeStrokecircle1;
  // stroke: rgb(255, 87, 51);

  @keyframes likecircle1 {
  0% {
    stroke-dashoffset: 52;
    fill: var(--grey);
  }

  70% {
    stroke-dashoffset: 0;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    // opacity: 0;
    fill: rgba(0, 176, 182, 0.0)
  }
}

@keyframes fadeStrokecircle1 {
    0%, 100% {
      stroke-width: 1;
    }
    50% {
      stroke-width: 0;
    }
  }
}

#circle2 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: rgb(0, 204, 255);

  width: 110px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 2, 6;
  stroke-dashoffset: 56;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 10s linear infinite likecircle2;

  @keyframes likecircle2 {
  0% {
    stroke-dashoffset: 56;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    fill: var(--grey);
  }

  // 100% {
  //   stroke-dashoffset: 0;
  //   // opacity: 0;
  //   fill: rgba(0, 176, 182, 0.0)
  // }
}
}

#svg1 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 1.0);
  --magenta: url(#paint1_linear_238_280);

  // width: 150px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 300;
  stroke-dashoffset: 54;
  stroke-linejoin: round;
  stroke-linecap: round;
  transform-origin: center;
  animation: 2s ease-in-out infinite fadeStroke1;
  // stroke: rgb(255, 87, 51);

@keyframes fadeStroke1 {
    0%, 100% {
      stroke-width: 8;
    }
    60% {
      stroke-width: 14;
    }
    100% {
      stroke-width: 8;
    }
    20% {
      stroke-width: 4;
    }
  }
}

#svg2 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: url(#paint0_linear_238_280);

  // width: 150px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 380;
  stroke-dashoffset: 54;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 5s ease-in infinite like2,
  // 0.8s linear 2s 2 forwards beat2,
  5s ease-in-out infinite fadeStroke2;
  // stroke: rgb(255, 87, 51);

  @keyframes like2 {
  0% {
    stroke-dashoffset: 380;
    fill: var(--grey);
  }

  70% {
    stroke-dashoffset: 30;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    // opacity: 0;
    // transform: translateX(-100%);
    // fill: rgba(0, 36, 182, 0.3)
  }
}

@keyframes beat2 {
  0% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(0.9, 0.9);
  }

  100% {
    transform: scale(1, 1);
  }

}

@keyframes fadeStroke2 {
    0%, 100% {
      stroke-width: 12;
    }
    40% {
      stroke-width: 8;
    }
    100% {
      stroke-width: 0;
    }
  }
}

#bolt1 {
   animation: dropInY1 6s ease forwards;
   animation-delay: 200ms;

   @keyframes dropInY1 {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    30%, 100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

#boltX2 {
   animation: dropInX2 5s ease forwards;
   animation-delay: 0ms;

   @keyframes dropInX2 {
    0% {
      opacity: 0;
      transform: translateX(-100%);
    }
    30%, 100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
#boltX3 {
   animation: dropInX3 6s ease forwards;
   animation-delay: 0ms;

   @keyframes dropInX3 {
    0%, 30% {
      opacity: 0;
      transform: translateX(-100%);
    }
    30% {
      opacity: 1;
      transform: translateX(5%);
    }
    50% {
      opacity: 1;
      transform: translateX(0);
    }
  }
}

</style>
